import { Button, Flex, Image, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

import { getLinkPropsFromAction } from "~/core/utils/action.utils";
import type { SecondaryFooterProps } from "~/features/secondary-footer/SecondaryFooter";
import { useDirectus } from "~/shared/utils/directus/useDirectus";
import { getPictureData } from "~/shared/utils/get-picture-data";

export const FooterBottomButtons: FC<SecondaryFooterProps> = ({
  data,
  isActionInactive,
  getUrl,
  onCallAction,
}) => {
  const { getDirectusImage } = useDirectus();
  const buttons =
    data?.footer_navigation?.flatMap((item, index) => {
      const footerButton = item?.secondary_layout_footer_navigation_id;
      const controlAction = footerButton?.action;
      const {
        isInactive,
        href,
        handlePress: handlePressButton,
      } = getLinkPropsFromAction({
        onCallAction,
        getUrl,
        controlAction,
        isActionInactive,
      });

      if (isInactive) {
        return [];
      }

      const footerButtonIcon = getPictureData(footerButton?.icon);

      return [
        <Flex
          key={index}
          flexDirection={"column"}
          align="center"
          width={"100%"}
          justify={"center"}
        >
          <Button
            variant={"tertiary"}
            p={{ py: 0, px: 0 }}
            onPress={handlePressButton}
            href={href}
          >
            <Flex gap={2} flexDirection={"column"} align={"center"}>
              <Image
                value={getDirectusImage(footerButtonIcon.id, {
                  width: footerButtonIcon.mWidth
                    ? footerButtonIcon.mWidth * 2
                    : undefined,
                  height: footerButtonIcon.mHeight
                    ? footerButtonIcon.mHeight * 2
                    : undefined,
                  format: "webp",
                  quality: 75,
                })}
                image={{
                  alt: footerButtonIcon.altText,
                }}
                width={footerButtonIcon.mWidth}
                height={footerButtonIcon.mHeight}
              />
              <Typography
                fontSize={"body.mobile.xsmall"}
                lineHeight={"body.mobile.xsmall"}
                color={
                  index === 0
                    ? "text-primary-default"
                    : "text-secondary-default"
                }
              >
                {footerButton?.translations?.[0]?.action_text}
              </Typography>
            </Flex>
          </Button>
        </Flex>,
      ];
    }) ?? [];

  if (!buttons.length) {
    return null;
  }

  return (
    <Flex
      align="center"
      justify="center"
      gap={0}
      minHeight={56}
      position={{
        type: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 20,
      }}
      d={{ display: "hidden" }}
      bg="background-tetriary"
    >
      {buttons}
    </Flex>
  );
};
